<template>
    <div
        class="pointer-events-none max-w-full text-center whitespace-nowrap"
    >
        <button
            v-if="outline && !pink"
            :type="type"
            class="text-[18px] rounded-full p-2 text-gray-600 border bg-white"
            :class="{'pointer-events-auto border-gray-600': !disabled, 'border-gray-400': disabled, 'w-[140px] md:w-[214px]': !isPopup, 'w-[136px]': isPopup}"
            :disabled="disabled"
        >
            {{ text }}
        </button>
        <button
            v-if="!outline && !pink"
            :type="type"
            class="text-[18px] rounded-full p-2 border"
            :class="{'pointer-events-auto bg-yellow text-black': !disabled, 'bg-gray-200 text-gray-600': disabled, 'w-[140px] md:w-[214px]': !isPopup, 'w-[136px]': isPopup}"
            :disabled="disabled"
        >
            {{ text }}
        </button>
        <button
            v-if="outline && pink"
            :type="type"
            class="text-[18px] rounded-full p-2 text-pink border bg-white"
            :class="{'pointer-events-auto border-pink': !disabled, 'border-gray-400': disabled, 'w-[140px] md:w-[214px]': !isPopup, 'w-[136px]': isPopup}"
            :disabled="disabled"
        >
            {{ text }}
        </button>
        <button
            v-if="!outline && pink"
            :type="type"
            class="text-[18px] rounded-full p-2 border"
            :class="{'pointer-events-auto bg-pink text-white': !disabled, 'bg-gray-200 text-gray-600': disabled, 'w-[140px] md:w-[214px]': !isPopup, 'w-[136px]': isPopup}"
            :disabled="disabled"
        >
            {{ text }}
        </button>
    </div>
</template>

<script>
/**
 * 表單-按鈕(1)實心，如下一步、立即試算
 * 表單-按鈕(2)框線，如返回
 * 彈跳視窗-按鈕，如提醒視窗的確定
 */
export default {
    name: 'FormButton',
    props: {
        /**
         * 按鈕文字
         */
        text: {
            type: String,
            default: '確定'
        },
        /**
         * 共用按鈕是pink還是yellow
         */
        pink: {
            type: Boolean,
            default: false
        },
        /**
         * 按鈕外觀線條
         */
        outline: {
            type: Boolean,
            default: false
        },
        /**
         * 是否可點擊
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * 按鈕類型
         */
        type: {
            type: String,
            default: 'button'
        },
        /**
         * 是否是彈窗 => 彈窗內的按鈕 寬度較窄
         */
        isPopup: {
            type: Boolean,
            default: false
        },
    }
};
</script>
